
export const products = {
  'product.categories': '제품 카테고리',
  'explore.solutions': '전문 AV 솔루션의 포괄적인 범위를 탐색하세요',
  'view.video': '제품 개요 비디오 보기',
  'AV Over IP': 'IP 기반 AV',
  'ReAX Control': 'ReAX 제어',
  'Meeting Room Solutions': '회의실 솔루션',
  'Converters/Scalers': '컨버터/스케일러',
  'Audio Products': '오디오 제품',
  'HDMI Switchers': 'HDMI 스위처',
  'IPBaseT': 'IPBaseT',
  'HDBaseT Products': 'HDBaseT 제품',
  'Complete AV distribution solution with ultra-low latency': '초저지연 완벽한 AV 분배 솔루션',
  'Professional control system solutions': '전문 제어 시스템 솔루션',
  'Complete solutions for modern meeting spaces': '현대 회의 공간을 위한 완벽한 솔루션',
  'Professional format conversion and scaling solutions': '전문 형식 변환 및 스케일링 솔루션',
  'Professional audio processing and playback solutions': '전문 오디오 처리 및 재생 솔루션',
  'Professional HDMI switching and distribution solutions': '전문 HDMI 전환 및 분배 솔루션',
  'Advanced IP-based AV distribution platform': '고급 IP 기반 AV 분배 플랫폼',
  'Professional HDBaseT distribution solutions': '전문 HDBaseT 분배 솔루션',
  'group.not.found': '그룹을 찾을 수 없습니다',
  'product.not.found': '제품을 찾을 수 없습니다',
  'return.to.home': '홈으로 돌아가기',
  'back.to.product.group': '제품 그룹으로 돌아가기',
  'overview': '개요',
  'full.description': '전체 설명',
  'features': '기능',
  'specifications': '사양',
};
